export default class TopicsTab {
  constructor(elem, opts) {
    this.elm = elem

    this.eventBinds()
  }

  eventBinds() {
    this.topicsContentFilter()
  }

  // URLのパラメータによってフィルターをかけるかどうか判定する
  topicsContentFilter(){
    const query = location.search.replace('?', '')
    if(query !== ''){
      if(query.includes('&')){
        const queryAry = query.split('&')
        for(let i=0; i<queryAry.length; i++){
          if(queryAry[i].includes('category')){
            const categoryName = queryAry[i].split('=')[1]
            this.topicsCategoryFilter(categoryName)
          }else if(queryAry[i].includes('tag')){
            const tagName = queryAry[i].split('=')[1]
            this.topicsTagFilter(tagName)
          }
        }
      }else{
        if(query.includes('category')){
          const categoryName = query.split('=')[1]
          this.topicsCategoryFilter(categoryName)
        }else if(query.includes('tag')){
          const tagName = query.split('=')[1]
          this.topicsTagFilter(tagName)
        }
      }
    }else{
      this.topicsActivateAll()
    }
  }

  // topicsのcategoryで記事サムネイルをフィルター
  topicsCategoryFilter(category){
    const topicsListElmAry = document.getElementsByClassName('js-topics-filter')
    for(let i=0; i<topicsListElmAry.length; i++){
      const datasetCategory = topicsListElmAry[i].dataset.category
      if(datasetCategory === category){
        if(!topicsListElmAry[i].classList.contains('is-active')){
          topicsListElmAry[i].classList.add('is-active')
        }
      }
    }
    this.topicsActivate()

    const categorySortLinkAry = Array.from(document.querySelectorAll('[data-filtercategorylink]'));
    categorySortLinkAry.forEach((el) => {
      if(el.dataset.filtercategorylink === category){
        el.classList.add('is-current')
      }
    });
  }

  // topicsのtagで記事サムネイルをフィルター
  topicsTagFilter(tag){
    const topicsListElmAry = document.getElementsByClassName('js-topics-filter')
    for(let i=0; i<topicsListElmAry.length; i++){
      const datasetTagAry = JSON.parse(topicsListElmAry[i].dataset.tag)
      for(let j=0; j<datasetTagAry.length; j++){
        if(datasetTagAry[j].id === tag){
          if(!topicsListElmAry[i].classList.contains('is-active')){
            topicsListElmAry[i].classList.add('is-active')
          }
        }
      }
    }
    this.topicsActivate()

    const tagSortLinkAry = Array.from(document.querySelectorAll('[data-filtertaglink]'));
    tagSortLinkAry.forEach((el) => {
      if(el.dataset.filtertaglink === tag){
        el.classList.add('is-current')
      }
    });
  }

  // topics全記事のサムネイルを表示
  topicsActivateAll(){
    const topicsListElmAry = document.getElementsByClassName('js-topics-filter')
    for(let i=0; i<topicsListElmAry.length; i++){
      topicsListElmAry[i].classList.add('is-active')
    }
    const topicsAllLink = document.getElementById('jsTopicsAllLink')
    topicsAllLink.classList.add('is-deactive')
    this.topicsActivate()
  }

  // topicsサムネイルエリアを表示
  topicsActivate(){
    const topicsWrapElm = document.getElementById('jsTopicsContentWrap')
    topicsWrapElm.classList.add('is-active')
    const topicsFilterContainerElm = document.getElementById('jsTopicsFilterContainer')
    topicsFilterContainerElm.classList.add('is-active')
  }
}